import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientDeliverablesPage from "@/pages/client/ClientDeliverablesPage";

export const Route = createFileRoute("/client/deliverables")({
  head: () => pageHead("Client · Deliverables", "AKIVA client · deliverables portal.", "/client/deliverables", true),
  component: ClientDeliverablesPage,
});
